export const Registry = new Map<string, any>();
export function Register(alias?: string) {
    return (target: any) => {
        const key = alias ? alias : target.name;
        Registry.set(key, target);
    };
}
